/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVolume: {
  name: 'volume';
  data: string;
} = {
  name: 'volume',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.246 2.565A.5.5 0 0 1 9.5 3v10a.5.5 0 0 1-.757.429L3.98 10.57a.5.5 0 0 0-.257-.071H2A1.5 1.5 0 0 1 .5 9V7A1.5 1.5 0 0 1 2 5.5h1.723a.5.5 0 0 0 .257-.071L8.743 2.57a.5.5 0 0 1 .503-.006ZM8.5 3.883 4.495 6.286a1.5 1.5 0 0 1-.772.214H2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h1.723a1.5 1.5 0 0 1 .772.214L8.5 12.117V3.883Zm2 .117a.5.5 0 0 1 .5-.5 4.5 4.5 0 1 1 0 9 .5.5 0 0 1 0-1 3.5 3.5 0 1 0 0-7 .5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1 1.5 1.5 0 0 1 0 3 .5.5 0 0 0 0 1 2.5 2.5 0 0 0 0-5Z" fill="currentColor"/></svg>`,
};
